export default "<div class=\"language-switch align-middle\">\r\n  <input type=\"text\" id=\"country\" readonly>\r\n</div>\r\n";